import { render } from "./CloneFacilityModal.vue?vue&type=template&id=13e31bfc"
import script from "./CloneFacilityModal.vue?vue&type=script&lang=js"
export * from "./CloneFacilityModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__